"use strict";

exports.__esModule = true;
exports.Event = void 0;
/*
 * COPYRIGHT 2020-2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var Event = /*#__PURE__*/function () {
  function Event(payload, source) {
    /** @private */
    this.payload = payload;
    /** @private */
    this.source = source ? source : null;
  }
  var _proto = Event.prototype;
  _proto.getPayload = function getPayload() {
    return this.payload;
  };
  _proto.getSource = function getSource() {
    return this.source;
  };
  return Event;
}();
exports.Event = Event;